import { gql } from '@apollo/client';
import SPECIFICATION from '../fragments/SPECIFICATION';
const DUPLICATE_MODEL = gql `
  ${SPECIFICATION}
  mutation DuplicateModel($modelSpecificationId: ID!, $newSpecificationItemCode: String!) {
    copyModelSpecification(
      modelSpecificationId: $modelSpecificationId
      newSpecificationItemCode: $newSpecificationItemCode
    ) {
      modelSpecification {
        ...SpecificationFragment
      }
    }
  }
`;
export default DUPLICATE_MODEL;
